const Review = ({ title, designation, message, name, image }: any) => {
  return (
    <section
      className="testimonial__area-five section-pb-130 mt-50"
      style={{
        paddingTop: 0,
        // paddingRight: 20,
        paddingBottom: 50,
        marginBottom: 100,
      }}
    >
      <div className="container mobile-review">
        <div className="row align-items-center justify-content-center">
          <div className="col-xl-6 col-lg-6 col-md-8">
            <div className="testimonial__img-three tg-svg">
              <div
                className="testimonial__mask-Image"
                style={{ height: "100%" }}
              >
                <img
                  src={image?.node?.sourceUrl}
                  alt="img-text"
                  width={530}
                  style={{ objectFit: "cover", objectPosition: "top" }}
                />
              </div>

              <div className="testimonial__img-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="33"
                  height="26"
                  viewBox="0 0 33 26"
                  fill="none"
                  data-inject-url="https://html.themegenix.com/skillgro/assets/img/icons/quote02.svg"
                  className="injectable"
                >
                  <path
                    d="M30.2004 22.2757C27.8861 24.7474 24.3843 26.0002 19.7938 26.0002L18.1443 26.0002L18.1443 21.4194L19.4705 21.1577C21.7303 20.7125 23.3022 19.8366 24.1435 18.5512C24.5824 17.8588 24.8313 17.0659 24.8659 16.2502L19.7938 16.2502C19.3563 16.2502 18.9368 16.079 18.6274 15.7743C18.3181 15.4695 18.1443 15.0562 18.1443 14.6252L18.1443 3.25025C18.1443 1.45787 19.6239 0.000246786 21.4433 0.000246945L31.3401 0.00024781C31.7776 0.000247848 32.1972 0.171451 32.5065 0.476198C32.8158 0.780945 32.9896 1.19427 32.9896 1.62525L32.9896 9.75025L32.9847 14.4936C32.9995 14.674 33.3129 18.9477 30.2004 22.2757ZM3.29896 0.000245359L13.1959 0.000246224C13.6333 0.000246262 14.0529 0.17145 14.3622 0.476197C14.6715 0.780943 14.8453 1.19427 14.8453 1.62525L14.8453 9.75024L14.8404 14.4936C14.8552 14.674 15.1686 18.9477 12.0561 22.2757C9.74184 24.7474 6.23998 26.0002 1.64948 26.0002L-3.8147e-06 26.0002L-3.41422e-06 21.4194L1.32618 21.1577C3.58597 20.7125 5.15793 19.8366 5.99916 18.5512C6.4381 17.8588 6.68705 17.0659 6.72164 16.2502L1.64948 16.2502C1.21201 16.2502 0.792455 16.079 0.483117 15.7743C0.173779 15.4695 -2.85794e-06 15.0562 -2.82026e-06 14.6252L-1.82583e-06 3.25025C-1.66913e-06 1.45787 1.47958 0.0002452 3.29896 0.000245359Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </div>
              <span
                className="svg-icon"
                id="testimonial-svg"
                data-svg-icon={"/assets/img/others/h6_testimonial_shape.svg"}
              ></span>
            </div>
          </div>
          <div className="col-xl-6 col-lg-6">
            <div className="testimonial__content-three testimonial__content-four">
              <div className="section__title mb-25">
                <h2 className="title bold">{title || "Chairman's Message"}</h2>
              </div>
              <div className="swiper-container testimonial-active-four swiper-initialized swiper-horizontal swiper-backface-hidden">
                <div
                  className="swiper-wrapper"
                  id="swiper-wrapper-d7068299087763ba"
                  aria-live="polite"
                >
                  <div
                    className="swiper-slide swiper-slide-active"
                    role="group"
                    aria-label="1 / 3"
                    data-swiper-slide-index="0"
                    style={{ width: 602, marginRight: 30 }}
                  >
                    <div className="testimonial__item-four">
                      <div className="rating">
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                      </div>
                      {/* <p
                        style={{
                          textAlign: "justify",
                          padding: "0 0 0 20px",
                          marginBottom: 30,
                          fontSize: 19,
                        }}
                      > */}
                      <div dangerouslySetInnerHTML={{ __html: message }} />
                      {/* </p> */}
                      <div className="testimonial__bottom-two">
                        <h4 className="title">
                          {name || "Padma Shri Mr. Ramesh Sippy"}
                        </h4>
                        <span>
                          {designation ||
                            `Chairman, MESC, Renowned Indian Filmmaker,
                              Director, Producer & Educationist`}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="testimonial-pagination testimonial-pagination-two swiper-pagination-clickable swiper-pagination-bullets swiper-pagination-horizontal">
                  <span
                    className="swiper-pagination-bullet swiper-pagination-bullet-active"
                    tabIndex={0}
                    role="button"
                    aria-label="Go to slide 1"
                    aria-current="true"
                  ></span>
                  <span
                    className="swiper-pagination-bullet"
                    tabIndex={0}
                    role="button"
                    aria-label="Go to slide 2"
                  ></span>
                  <span
                    className="swiper-pagination-bullet"
                    tabIndex={0}
                    role="button"
                    aria-label="Go to slide 3"
                  ></span>
                </div> */}
                <span
                  className="swiper-notification"
                  aria-live="assertive"
                  aria-atomic="true"
                ></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Review;
